module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"8","height":"8","viewBox":"0 0 8 8"},"content":"<path d=\"M5.243 3.828L7.364 5.95A1 1 0 0 1 5.95 7.364L3.828 5.243l-2.12 2.121A1 1 0 0 1 .292 5.95l2.121-2.122-2.121-2.12A1 1 0 0 1 1.707.292l2.121 2.121L5.95.293a1 1 0 0 1 1.414 1.414L5.243 3.828z\"/>"}


//////////////////
// WEBPACK FOOTER
// ./client/components/Icon/images/new-cross.svg
// module id = 1425
// module chunks = 0